import React, {PureComponent} from 'react';
import AutoComplete from '../AutoComplete';
import withDadata from './withDadata';
import PropTypes from 'prop-types';
import {throttle} from 'modul-helpers';

const Option = AutoComplete.Option;

@withDadata({
	connectionString: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address?5',
	fromCount: 3,
	count: 10,
})
class DadataSuggest extends PureComponent {
	static propTypes = {
		autoload: PropTypes.bool,
		disabled: PropTypes.bool,
		defaultActiveFirstOption: PropTypes.bool,
		canTypeCustomAddress: PropTypes.bool,
		fetchDelay: PropTypes.number,
		className: PropTypes.string,
		searchFieldClassName: PropTypes.string,
		defaultValue: PropTypes.string,
		children: PropTypes.object,
		suggestions: PropTypes.array,
		onBlur: PropTypes.func,
		onChange: PropTypes.func,
		onInputChange: PropTypes.func,
		onKeyPress: PropTypes.func,
		fetchSuggestions: PropTypes.func,
		onSuggestionClick: PropTypes.func,
		handleClear: PropTypes.func,
	};

	static defaultProps = {
		fetchDelay: 400,
	};

	static getDerivedStateFromProps(props) {
		const {suggestions} = props;

		return {
			suggestions,
		};
	}

	state = {
		value: null,
	};

	onInputChange = data => {
		const {onKeyPress} = this.props;

		const newState = {
			value: data,
		};

		/**
		 * Если передан обработчик по нажатию клавиши, передаём туда текущую строку адреса.
		 * Это может быть необходимо, чтобы в моменте отслеживать текущий адрес
		 * и устанавливать стейт у родителей.
		 * */
		if (onKeyPress) {
			onKeyPress(data);
		}

		this.setState(newState, () => data && this.throttledInputChange(data));
	};

	throttledInputChange = throttle(data => this.props.onInputChange(data),
		this.props.fetchDelay);


	onSuggestionClick = suggestionValue => {
		// Поиск индекса варианта в списке
		const address = this.state.suggestions.find(s => s.value === suggestionValue);
		const {canTypeCustomAddress} = this.props;

		if (address) {
			this.setState({
				value: address.unrestricted_value,
			}, () => this.props.onSuggestionClick(suggestionValue));
		}

		/**
		 * Когда введён кастомный адрес, onChange из HOC'а не подходит,
		 * так как он работает только с существующими адресами из DaData.
		 * Вызываем onChange из пропсов напрямую.
		 * */
		if (canTypeCustomAddress
			&& this.props.onChange) {
			this.props.onChange(address);
		}
	};

	handleClear = () => {
		this.props.handleClear();
		this.setState({
			suggestions: [],
			query: '',
			value: null,
		});
	};

	render() {
		const {
			disabled,
			className,
			defaultValue,
			onBlur,
			children,
			defaultActiveFirstOption,
		} = this.props;

		const {
			value,
			suggestions,
		} = this.state;

		return (
			<AutoComplete
				disabled={disabled}
				className={className}
				optionLabelProp="value"
				defaultValue={defaultValue}
				dataSource={
					!!value && value.length > 0 && suggestions && suggestions.map(suggestion => {
						return <Option key={suggestion.value}>{suggestion.unrestricted_value}</Option>;
					})
				}
				value={value !== null ? value : defaultValue}
				onBlur={onBlur}
				onSelect={this.onSuggestionClick}
				onSearch={this.onInputChange}
				defaultActiveFirstOption={defaultActiveFirstOption}
			>{
					children && React.cloneElement(
						children,
						{
							handleClear: this.handleClear
						})
				}
			</AutoComplete>
		);
	}
}

export default DadataSuggest;
